



























import Vue from 'vue';
import { sanityClient } from '@/config/sanity';
import SanityBlockContentModel from '@/models/sanitySchema/sanityBlockContent';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import SpeakerWithGradient from '@/components/SpeakerWithGradient.vue';

interface PensionPage {
  title: string;
  content: SanityBlockContentModel;
}

interface Data {
  isLoading: boolean;
  error: string;
  page: PensionPage | null;
}

export default Vue.extend({
  name: 'Pension',
  components: {
    LoadingIndicator,
    ErrorMessage,
    SanityBlockContent,
    SpeakerWithGradient,
  },
  data(): Data {
    return {
      isLoading: true,
      error: '',
      page: null,
    };
  },
  created() {
    this.fetchPage();
  },
  methods: {
    fetchPensionPage() {
      const query = `*[_type == "pensionPage"]{
        "createdAt": _createdAt,
        "updatedAt": _updatedAt,
        "id": _id,
        "key": _key,
        "slug": slug.current,
        title,
        content,
        rates,
        gLink,
      }[0]`;

      return sanityClient.fetch(query).then(
        (results) => {
          this.page = results;
        },
        (error) => {
          this.error = error;
        },
      );
    },
    fetchPage() {
      this.isLoading = true;
      Promise.all([
        this.fetchPensionPage(),
      ]).then(() => {
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
  },
});
